module.exports = __webpack_public_path__ + "img/ticketBg1.06768945.jpg";